import styled from 'styled-components';

const Wrapper = styled.div`
  form {
    display: flex;
    flex-direction: column;
  }

  .divider {
    border-top: 1px solid ${(props) => props.theme.colors.grey};
    opacity: 0.3;
    margin: 5px 0;
    width: 100%;
  }
  .device-configuration {
    h4 {
      font-family: ManropeLight, sans-serif;
      font-size: 16px;
      cursor: default;
      padding: 10px 16px;
      font-weight: bold;
    }
    
    .loading {
      font-style: italic;
      margin-top: 10px;
      font-family: ManropeLight, sans-serif;
      font-size: 12px;
      cursor: default;
      color: ${(props) => props.theme.colors.grey};
    }
    
    p.loading {
      font-style: italic;
      font-size: 14px;
      margin-top: 100px;
      text-align: center;
    }

    p.message {
      font-style: italic;
      font-size: 12px;
      margin-top: 10px;
    }

    p.error {
      color: ${(props) => props.theme.colors.red};
    }

    p.warning {
      color: ${(props) => props.theme.colors.orange};
    }

    .hidden {
      display: none;
    }
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  p {
    padding: 10px 16px;
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    width: 300px;
  }

  div {
    width: 250px;
    padding: 10px 16px;
  }
`;

const Buttons = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  button {
    min-width: 135px;
  }

  .save-button {
    background-color: ${(props) => props.theme.colors.main_cta};
    color: ${(props) => props.theme.colors.widget_background};

    &:hover {
      background-color: ${(props) => props.theme.colors.widget_hover_background};
      color: ${(props) => props.theme.colors.main_cta};
    }

    &:disabled {
      cursor: default;
      background-color: ${(props) => props.theme.colors.inactive};
      color: ${(props) => props.theme.colors.black};
    }
  }
`;

const RowContainer = styled.div<{ $hide?: boolean; }>`
  width: 100%;
  max-width: 100%;
  display: ${(props) => (props.$hide ? 'none' : 'flex')};
  gap: 16px;
  padding: 5px 16px;

  .input-component {
    width: 100%;
    margin-top: 5px;
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
`;

export default {
  Wrapper, Row, RowContainer, Buttons, ErrorMessage,
};
